const ACTION_TYPES = require('constants/actionTypes/brandsList');

const initialState = {
    userFavoriteBrandIDs: []
};

const setUserFavoriteBrandIDs = (state, action) => {
    return {
        ...state,
        userFavoriteBrandIDs: action.payload.userFavoriteBrandIDs
    };
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_USER_FAVORITE_BRANDS:
            return setUserFavoriteBrandIDs(state, action);
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
